const formatOneTimeCharges = (oneTimeCharges = {}, currencyCode) => {
  const { setupFee, shippingAmount, taxes, productPrice } = oneTimeCharges;
  const totalPrice = Object.values(oneTimeCharges).reduce((prev, curr) => prev + Number(curr), 0);

  return {
    setup_fee:
      setupFee !== '0'
        ? {
            value: setupFee,
            currency_code: currencyCode
          }
        : undefined,
    shipping_amount:
      shippingAmount !== '0'
        ? {
            value: shippingAmount,
            currency_code: currencyCode
          }
        : undefined,
    taxes:
      taxes !== '0'
        ? {
            value: taxes,
            currency_code: currencyCode
          }
        : undefined,
    product_price: {
      value: productPrice,
      currency_code: currencyCode
    },
    total_amount: {
      value: totalPrice,
      currency_code: currencyCode
    }
  };
};

export default formatOneTimeCharges;
